import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Markup } from 'interweave';

export default function OurOfferings(){
    const { t } = useTranslation();
    const offerings = ["corebanking", "credits", "directchannels", "investments", "sellaleasing", "payments", "hrsystems", "fabrick"];

    return(
        <article id="ourofferings">
            <section className="our-offerings">
                <Container>
                    <Row>
                        <Col>
                            <div class="section-highlight">{t('whatwedo.ourofferings.title')}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="content-container">
                                {offerings.map(item=>{
                                    return(
                                        <Row className="mb-4" id={item}>
                                            <Col md={2}>
                                                <div className={`icon-placeholder ${item}`}>
                                                    <div className="icon"></div>
                                                </div>
                                            </Col>
                                            <Col md={10}>
                                                <div className="title">{t(`whatwedo.ourofferings.${item}.title`)}</div>
                                                <div className="description"><Markup content={t(`whatwedo.ourofferings.${item}.description`)}></Markup></div>
                                            </Col>
                                        </Row>
                                    )
                                })}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </article>
    )
}